import { cn } from '~/utils/cn';

/** The three states an attribute can be in, shared by every panel on the tab.
 *  Green is the only accent — "restated" is a neutral rather than a warning,
 *  which also keeps the two fills distinguishable for red-green colour blindness. */
export type GapTone = 'had' | 'restated' | 'added';

const SWATCH: Record<GapTone, string> = {
  had: 'border-[1.5px] bg-background',
  restated: 'bg-muted-foreground',
  added: 'bg-success',
};

interface Props {
  /** Rendered in order; omit the entries a given product has no rows for. */
  items: { tone: GapTone; label: string }[];
  className?: string;
  /** Root `data-testid`; each entry gets `${testId}-item-${tone}`. */
  testId?: string;
}

/** Legend strip. Every fill on the tab is also labelled in text somewhere, so
 *  colour is never the sole carrier of meaning. */
export function GapLegend({ items, className, testId = 'gap-analysis-legend' }: Props) {
  return (
    <div className={cn('flex flex-wrap gap-x-4 gap-y-1', className)} data-testid={testId}>
      {items.map((item) => (
        <span
          key={item.tone}
          data-testid={`${testId}-item-${item.tone}`}
          className="text-muted-foreground inline-flex items-center gap-1.5 text-[11.5px]"
        >
          <span className={cn('size-2.5 shrink-0 rounded-sm', SWATCH[item.tone])} />
          {item.label}
        </span>
      ))}
    </div>
  );
}
